export default __webpack_public_path__ + "static/teamsImg2-19a838021d2e1e131e97409f64e90967.webp";